<script>
import Badge from '@phoenix/mixins/components/checkout/summary/Badge';
import { PhxIcon } from '@phx-styleguides/iwc';

export default {
  components: { PhxIcon },

  mixins: [Badge],

  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<template>
  <phx-icon :icon="countFromLocalStorage > 0 ? 'bag-active' : 'bag'" :title="title" />
</template>
